import { AppEnvironments } from "constants/appEnvironments";

const appEnvironment = process.env.REACT_APP_RUM_ENV || AppEnvironments.Development;

export const isProductionEnvironment = (): boolean => {
  return !!process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === "production";
};

export const isPreProductionEnvironment = (): boolean => {
  return appEnvironment === AppEnvironments.PreProduction;
};

export const isProductionFedRampEnvironment = (): boolean => {
  return appEnvironment === AppEnvironments.ProductionFedRAMP;
};

export const isPreProductionFedRampEnvironment = (): boolean => {
  return appEnvironment === AppEnvironments.PreProductionFedRAMP;
};

export const isProductionUsEnvironment = (): boolean => {
  return appEnvironment === AppEnvironments.ProductionUs;
};
